const MOBILE_WIDTH = 650

export const isMobile = () => window.innerWidth <= MOBILE_WIDTH

export const isHebrew = (text: string) => /^[א-ת]+$/.test(text)